module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/236.b265fc9c.png";